import React, { Component, createRef } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

// Api
import CommonApis from "../../helper/common.api";
import OrganizationApis from "../../helper/organization.api";

// Css
import "../../styles/Organization.css";

// Icon
import {
  AiOutlineCloudUpload,
  AiFillCloseCircle,
  AiFillPlusCircle,
  AiOutlineMinusCircle,
} from "react-icons/ai";
import { BsTelephoneFill } from "react-icons/bs";
import { RiFacebookFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import loco from "../../images/games/loco.png";

// Utils
import { profile } from "../../utils/localstorage.utils";

import AddMoreDetails from "../popup/AddMoreDetails";
import { errorHandler, loadCountryCodes } from "../../utils/common.utils";
import { capitalize } from "../../utils/common.utils";
import { createAndSendNotification } from "../../utils/notification.utils";
import ImageCropper from "../common/ImageCropper/ImageCropper";

class CreateOrganization extends Component {
  commonApi = new CommonApis();
  organizationApi = new OrganizationApis();
  orgLogoUrl;
  orgCoverUrl;
  images = {
    orgLogo: null,
    orgCover: null,
  };
  profile = profile();
  extraDetails = [
    { label: "instagram", key: "instagram", value: "", isChecked: false, error: "" },
    { label: "Facebook", key: "facebook", value: "", isChecked: false, error: "" },
    { label: "X", key: "x", value: "", isChecked: false, error: "" },
    { label: "telegram", key: "telegram", value: "", isChecked: false, error: "" },
    { label: "youtube", key: "youtube", value: "", isChecked: false, error: "" },
    { label: "loco", key: "loco", value: "", isChecked: false, error: "" },
    //{ label: "smash", key: 'smash', value: '', isChecked: false, error: ''},
    { label: "twitch", key: "twitch", value: "", isChecked: false, error: "" },
  ];

  constructor(props) {
    super(props);
    this.state = {
      orgLogo: null,
      orgCover: null,
      addDetails: false,
      recaptcha: "",
      load: false,
      expired: "false",
      appendDetails: false,
      extraDetails: this.extraDetails,
      openPageLayout: false,
      websiteLink:
        window.location.hostname === "localhost"
          ? import.meta.env.VITE_APP_WEB_URL
          : window.location.origin,
      description: "",
      countryCodes: [],
      countryCode1: global?.countryode ? global.countryCode : "+91",
      countryCode2: global?.countryode ? global.countryCode : "+91",
      // Cropper state
      showLogoCropper: false,
      showBannerCropper: false,
      logoCropperImageUrl: "",
      bannerCropperImageUrl: "",
      logoCropperAspectRatio: 1, 
      bannerCropperAspectRatio: 1189/150, 
    };
    this._reCaptchaRef = createRef();
    //this.getCodes();
  }
  componentDidMount() {
    this.props.showOrHideNav(true);
    // setTimeout(() => {
    //     this.setState({ load: true });
    // }, DELAY);
    console.log("global.countryCode app - ", global.countryCode);
    loadCountryCodes(this.setCountryCodes);
    this.setState({
      countryCode1: global?.countryCode ? global.countryCode : "+91",
      countryCode2: global?.countryCode ? global.countryCode : "+91",
    });
  }

  setCountryCodes = codes => {
    if (codes) {
      this.setState({ countryCodes: codes, country: JSON.stringify(codes[0]) });
    }
  };

  getCodes = () => {
    this.props.updateLoader(true);
    this.commonApi
      .getCountryCodes()
      .then(res => {
        this.props.updateLoader(false);
        this.setState({ countryCodes: res.data.result });
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err);
      });
  };

  //To reset images
  resetLogo = id => {
    let key = id;
    this.setState({ [key]: null });
    this.images[key] = {};
  };

  //To open files
  triggerInputFile = () => this.fileInput.click();
  triggerInputFile2 = () => this.fileInput2.click();

  //For Reptcha
  handleChange = value => {
    this.setState({ recaptcha: value });

    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };

  //Upload images
  addImg = (event, key) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      if (!img.name.match(/\.(jpg|jpeg|png)$/)) {
        toast.warning("Please select a valid image type.");
        event.target.value = null; 
        return false;
      }
      if (key === "orgLogo") {
        this.setState({
          showLogoCropper: true,
          logoCropperImageUrl: URL.createObjectURL(img),
          logoCropperAspectRatio: 1,
        });
      } else if (key === "orgCover") {
        this.setState({
          showBannerCropper: true,
          bannerCropperImageUrl: URL.createObjectURL(img),
          bannerCropperAspectRatio: 1189/150, 
        });
      }
      event.target.value = null; 
    }
  };

  // Handle logo cropper completion
  handleLogoCropComplete = (croppedImageUrl, blob) => {
    this.setState({
      orgLogo: croppedImageUrl,
      showLogoCropper: false,
    });

    const formData = new FormData();
    formData.append("file", blob);
    this.props.updateLoader(true);
    this.commonApi
      .uploadSingleImg(formData)
      .then(response => {
        this.images.orgLogo = response.data.result;
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.props.updateLoader(false);
        console.log(err);
      });
  };

  // Handle banner cropper completion
  handleBannerCropComplete = (croppedImageUrl, blob) => {
    this.setState({
      orgCover: croppedImageUrl,
      showBannerCropper: false,
    });

    const formData = new FormData();
    formData.append("file", blob);
    this.props.updateLoader(true);
    this.commonApi
      .uploadSingleImg(formData)
      .then(response => {
        this.images.orgCover = response.data.result;
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.props.updateLoader(false);
        console.log(err);
      });
  };

  // Hide logo cropper
  hideLogoCropper = () => {
    this.setState({
      showLogoCropper: false,
      logoCropperImageUrl: "",
      logoCropperAspectRatio: 1,
    });
  };

  // Hide banner cropper
  hideBannerCropper = () => {
    this.setState({
      showBannerCropper: false,
      bannerCropperImageUrl: "",
      bannerCropperAspectRatio: 1189/150,
    });
  };

  //Create Orginazation
  onSubmit = values => {
    if (!this.images.orgLogo?.url) {
      this.images.orgLogo = null;
    }
    if (!this.images?.orgCover?.url) {
      this.images.orgCover = null;
    }
    // if (!this.state.recaptcha) {
    //     toast.error('Select recaptcha')
    //     return false
    // }
    // reCAPTCHA is commented out for now
    if (!values.whatsappNo && !values.discord) {
      toast.error("Enter whatsapp number or discord id");
      return false;
    }
    const data = {
      logo: this.images.orgLogo,
      coverImage: this.images?.orgCover,
      name: values.organizationName.trim(),
      contactPersonUsername: values.userName,
      contactPersonName: values.contactName,
      contactPersonNumber: { code: this.state.countryCode1, number: values.contactNumber },
      bio: values.description,
      members: {},
      microWebsiteLink: this.state.websiteLink,
      socialMediaDetails: {
        whatsapp: { code: this.state.countryCode2, number: values.whatsappNo },
        discord: values.discord ? values.discord : "",
      },
    };
    this.state.extraDetails.map(el => {
      if (el.value) {
        data.socialMediaDetails[el.key] = el.value;
      }
    });
    this.props.updateLoader(true);
    this.organizationApi
      .addNewOrganization(data)
      .then(res => {
        this.props.history.push(`/organization/micro-website/configuration/${res.data.result._id}`);
        var notification = {
          type: "ORGANIZATION",
          heading: "Organization Created 👍",
          message: `Your Organization '${data.name}' has been successfully created and you have been assigned as owner of your Organization.`,
          link: `/organization/view/${res.data.result._id}`,
        };
        createAndSendNotification(notification, [profile().id]);
        this.props.updateLoader(false);
        toast.success("Organization created successfully");
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  //Get website url on Org Name change
  getMicroWeb = e => {
    if (/^[_A-zA-Z]*((-|\s)*[_A-zA-Z])*$/g.test(e.target.value)) {
      const data = {
        name: e.target.value,
      };
      this.organizationApi
        .getMicroWebUrl(data)
        .then(res => {
          this.setState({ websiteLink: res.data.result });
        })
        .catch(err => {
          this.props.updateLoader(false);
          errorHandler(err, this.props.logout);
        });
    }
  };

  //Open close add more details
  addSocialMedia = e => {
    e.preventDefault();
    this.setState({ addDetails: !this.state.addDetails });
  };

  //to rander the selected details
  renderAddedDetails = details => {
    this.setState({ extraDetails: details, addDetails: false });
  };

  //add more details
  addMoreDetails = () => {
    this.setState(prevState => ({ addDetails: !prevState.addDetails }));
  };

  //Remove Details
  removeDetails = (event, value) => {
    event.preventDefault();
    const updateArr = this.state.extraDetails;
    let index = this.state.extraDetails
      .map(el => {
        return el.label;
      })
      .indexOf(value);
    updateArr[index].value = "";
    updateArr[index].isChecked = false;
    this.setState({ extraDetails: updateArr });
  };

  updateBio = e => {
    this.setState({ description: e.target.value });
  };

  setSession = (key, val) => {
    global.countryCode = val;
    this.setState({ [key]: val });
  };
  render() {
    return (
      <>
        <section className="body-section create-organization">
          <div className="container mt-lg-5 p-4">
            <h1 className="fs-20 fw-600 text-white mt-2 mb-4 text-center">Create Organization</h1>

            <div className="mb-4">
              <p className="fs-14 fw-600 text-white text-center">
                Create your organization to host tournaments, manage teams, and grow your gaming
                community! Get started by filling out the form below. Make sure to provide accurate
                contact information for better communication.
              </p>
            </div>

            <Formik
              innerRef={this.formikRef}
              initialValues={{
                organizationName: "",
                description: "",
                contactName: this.profile.name,
                contactNumber: "",
                userName: this.profile.username,
                whatsappNo: "",
                discord: profile()?.discordProfile?.discordUsername
                  ? profile()?.discordProfile?.discordUsername
                  : "",
                countryCode1: this.state.countryCode1,
                countryCode2: this.state.countryCode2,
              }}
              validationSchema={Yup.object({
                organizationName: Yup.string()
                  .trim()
                  .required("Organization Name is required")
                  .matches(/^[_A-zA-Z]*((-|\s)*[_A-zA-Z])*$/g, "Only alphabets allowed")
                  .max(50, "Max 50 characters"),
                description: Yup.string().trim().max(500, "Max 500 characters"),
                contactName: Yup.string().required("Contact Name is required"),
                contactNumber: Yup.string()
                  .matches(/^[0-9]*$/, "only numerics allowed")
                  .required("Mobile number is required")
                  .min(9, "min 9 digits required")
                  .max(12, "max 12 digits allowed"),
                userName: Yup.string(),
                whatsappNo: Yup.string()
                  .matches(/^[0-9]*$/, "only numerics allowed")
                  .min(9, "min 9 digits required")
                  .max(12, "max 12 digits allowed"),
                // discord: Yup.string().matches(/^.{3,32}#[0-9]{4}$/, 'Invalid Username'),
                discord: Yup.string(),
                countryCode1: Yup.string(),
                countryCode2: Yup.string(),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  this.onSubmit(values);
                  setSubmitting(false);
                }, 400);
              }}
              onChange={values => {
                this.getMicroWeb(values);
              }}
            >
              <Form className="row create-organization-form" autoComplete="off">
                <div className="col-lg-6 col-12 px-4">
                  <div className="row justify-content-center mt-2 mt-lg-3 align-items-center" style={{gap: '16px'}}>
                    <div className="col-auto p-0 me-2">
                      <div className="uploadWithPreview">
                        <div className="upload-section cursor-pointer">
                          <input
                            type="file"
                            id="upload_file"
                            accept=".png, .jpg, .jpeg"
                            hidden
                            ref={fileInput => (this.fileInput = fileInput)}
                            onChange={e => this.addImg(e, "orgLogo")}
                            name=""
                            className=""
                          />
                          {this.state.orgLogo ? (
                            <div
                              style={{
                                width: '100px',
                                height: '100px',
                                background: '#111',
                                borderRadius: '10px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative'
                              }}
                            >
                              <img
                                src={this.state.orgLogo}
                                alt=""
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                              />
                              <AiFillCloseCircle
                                className="btn-size-20 text-white"
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  right: 0,
                                  cursor: 'pointer',
                                  zIndex: 2,
                                  background: '#222',
                                  borderRadius: '50%'
                                }}
                                onClick={() => {
                                  this.resetLogo("orgLogo");
                                }}
                              />
                            </div>
                          ) : (
                            <div 
                              className="before-uploaded-panel"
                              style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '10px',
                                overflow: 'hidden'
                              }}
                            >
                              <div
                                className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                onClick={this.triggerInputFile}
                                style={{
                                  height: '100%'
                                }}
                              >
                                <div className="btn-size-30 d-flex flex-column justify-content-center">
                                  <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                  <h1
                                    className="fs-16 fw-600 text-white-50"
                                    htmlFor="exampleInputText"
                                  >
                                    Logo
                                  </h1>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-auto p-0 ms-2">
                      <div className="uploadWithPreview">
                        <div className="upload-section cursor-pointer">
                          <input
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            id="upload_cover_file"
                            hidden
                            onChange={e => this.addImg(e, "orgCover")}
                            ref={fileInput2 => (this.fileInput2 = fileInput2)}
                            name=""
                            className=""
                          />
                          {this.state.orgCover ? (
                            <div
                              style={{
                                width: '300px',
                                height: '80px',
                                background: '#111',
                                borderRadius: '10px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative'
                              }}
                            >
                              <img
                                src={this.state.orgCover}
                                alt=""
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                              />
                              <AiFillCloseCircle
                                className="btn-size-20 text-white"
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  right: 0,
                                  cursor: 'pointer',
                                  zIndex: 2,
                                  background: '#222',
                                  borderRadius: '50%'
                                }}
                                onClick={() => {
                                  this.resetLogo("orgCover");
                                }}
                              />
                            </div>
                          ) : (
                            <div 
                              className="before-uploaded-panel"
                              style={{
                                width: '300px',
                                height: '80px',
                                borderRadius: '10px',
                                overflow: 'hidden'
                              }}
                            >
                              <div
                                className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                onClick={this.triggerInputFile2}
                                style={{
                                  height: '100%'
                                }}
                              >
                                <div className="btn-size-30 d-flex flex-column justify-content-center">
                                  <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                  <h1
                                    className="fs-16 fw-600 text-white-50"
                                    htmlFor="exampleInputText"
                                  >
                                    Banner
                                  </h1>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <label
                      htmlFor="organizationName"
                      className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                    >
                      Organization Name*
                    </label>
                    <Field
                      name="organizationName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      placeholder="Enter Organization Name"
                      onKeyUp={this.getMicroWeb}
                    />
                    <ErrorMessage component="span" className="error-msg" name="organizationName" />
                  </div>
                  <div className="">
                    <label
                      htmlFor="websiteLink"
                      className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                    >
                      Micro-Website Link{" "}
                    </label>
                    <Field
                      disabled
                      name="websiteLink"
                      type="text"
                      as="textarea"
                      rows="3"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 no-resize"
                      placeholder={
                        window.location.hostname === "localhost"
                          ? import.meta.env.VITE_APP_WEB_URL
                          : window.location.origin
                      }
                      value={this.state.websiteLink}
                    />
                    <ErrorMessage component="span" className="error-msg" name="websiteLink" />
                  </div>
                  <div className="">
                    <div className="d-flex justify-content-between">
                      <label
                        htmlFor="description"
                        className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                      >
                        Description
                      </label>
                      <label
                        htmlFor="description"
                        className="fs-12  fw-600 text-white-50 mb-1 mt-2 mt-lg-3"
                      >{`${this.state.description?.length}/500`}</label>
                    </div>
                    <Field
                      name="description"
                      type="text"
                      as="textarea"
                      rows="4"
                      maxLength={500}
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 no-resize"
                      placeholder="Enter Description"
                      onKeyUp={e => this.updateBio(e)}
                    />
                    <ErrorMessage component="span" className="error-msg" name="description" />
                  </div>
                </div>
                <div className="col-lg-6 col-12 px-4">
                  <div className="d-flex mt-3" style={{ alignItems: "center" }}>
                    <hr className="border-1 flex-grow-1" style={{ height: "2px" }} />
                    <div className="d-flex mx-3" style={{ alignItems: "center" }}>
                      <BsTelephoneFill className="btn-size-20 me-2 text-white-50" />
                      <p className="fs-16 fw-bold text-white-50 mb-0">Contact Details</p>
                    </div>
                    <hr className="border-1 flex-grow-1" style={{ height: "2px" }} />
                  </div>

                  <div className="">
                    <label
                      htmlFor="contactName"
                      className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                    >
                      Contact Name*
                    </label>
                    <Field
                      name="contactName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      placeholder="Enter Contact Name"
                    />
                    <ErrorMessage component="span" className="error-msg" name="contactName" />
                  </div>
                  <div className="">
                    <label htmlFor="userName" className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3">
                      Espotz Username*
                    </label>
                    <Field
                      name="userName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      placeholder="Enter Espotz Username"
                      disabled={true}
                    />
                    <ErrorMessage component="span" className="error-msg" name="userName" />
                  </div>
                  <div className="">
                    <label
                      htmlFor="contactNumber"
                      className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                    >
                      Contact Number*
                    </label>
                    <Field
                      name="countryCode1"
                      value={this.state.countryCode1}
                      as="select"
                      onChange={e => this.setSession("countryCode1", e.target.value)}
                      className="sponsor-dropdown purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45 mb-1"
                    >
                      {this.state.countryCodes.map((el, i) => {
                        return <option value={el.code} key={i}>{`${el.code} ${el.name}`}</option>;
                      })}
                    </Field>
                    <Field
                      name="contactNumber"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      placeholder="Enter Contact Number"
                    />
                    <ErrorMessage component="span" className="error-msg" name="contactNumber" />
                  </div>
                  <div className="">
                    <label
                      htmlFor="contactNumber"
                      className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3"
                    >
                      WhatsApp Number*
                    </label>
                    <Field
                      name="countryCode2"
                      value={this.state.countryCode2}
                      as="select"
                      onChange={e => this.setSession("countryCode2", e.target.value)}
                      className="sponsor-dropdown purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45 mb-1"
                    >
                      {this.state.countryCodes.map((el, i) => {
                        return <option value={el.code} key={i}>{`${el.code} ${el.name}`}</option>;
                      })}
                    </Field>
                    <Field
                      name="whatsappNo"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      placeholder="Enter WhatsApp Number"
                    />
                    <ErrorMessage component="span" className="error-msg" name="whatsappNo" />
                  </div>
                  {/* <div className="">
                                        <label htmlFor="userName" className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3">Discord Username</label>
                                        <Field
                                            name="discord"
                                            type="text"
                                            disabled={true}
                                            //validate={this.validateDiscordUsername}
                                            className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                                            placeholder="mike#1234"
                                        />
                                        <ErrorMessage component="span" className="error-msg" name="discord" />
                                    </div> */}

                  {this.state.extraDetails.map((el, i) => {
                    return el.value !== "" && el.error === "" ? (
                      <div className="my-2" key={i}>
                        <div className="position-relative">
                          {/* Render React icon based on key, absolutely positioned inside input */}
                          {el.key === "instagram" && (
                            <AiFillInstagram
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "facebook" && (
                            <RiFacebookFill
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "x" && (
                            <FaXTwitter
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "twitch" && (
                            <FaTwitch
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "telegram" && (
                            <FaTelegramPlane
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "youtube" && (
                            <AiFillYoutube
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {el.key === "loco" && (
                            <img
                              src={loco}
                              className="position-absolute"
                              alt="loco"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          <input
                            type="text"
                            className="purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                            disabled
                            value={el.value}
                            style={{ paddingLeft: 40 }}
                          />
                          <AiOutlineMinusCircle
                            className="btn-size-20 me-3 text-white flex-shrink-0 position-absolute"
                            style={{
                              right: 10,
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                            onClick={e => this.removeDetails(e, el.label)}
                          />
                        </div>
                      </div>
                    ) : null;
                  })}

                  <div
                    className="form-group mt-3 mb-5 black-flat-btn d-flex justify-content-center align-items-center height-45 rounded-10 mx-auto cursor-pointer"
                    style={{ maxWidth: "320px" }}
                    onClick={e => this.addSocialMedia(e)}
                  >
                    <AiFillPlusCircle className="btn-size-20 text-white" />
                    <span className="text-white fw-bold ms-1 cursor-pointer">Add Social Media</span>
                    {/* <label htmlFor="addSocialMedia">Add Social Media</label> */}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    className="white-flat-btn d-block fw-bold py-2 px-4 m-auto mt-3 mb-3 position-fixed"
                    style={{ bottom: "60px" }}
                  >
                    Create
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </section>

        <Modal show={this.state.addDetails} centered dialogClassName="AddMoreDetails-modal">
          <Modal.Body>
            <AddMoreDetails
              data={this.state.extraDetails}
              addMoreDetails={this.addMoreDetails}
              renderAddedDetails={this.renderAddedDetails}
            />
          </Modal.Body>
        </Modal>

        <ImageCropper
          show={this.state.showLogoCropper}
          onHide={this.hideLogoCropper}
          imageUrl={this.state.logoCropperImageUrl}
          aspectRatio={this.state.logoCropperAspectRatio}
          onCropComplete={this.handleLogoCropComplete}
          width={800}
          height={800}
        />

        <ImageCropper
          show={this.state.showBannerCropper}
          onHide={this.hideBannerCropper}
          imageUrl={this.state.bannerCropperImageUrl}
          aspectRatio={this.state.bannerCropperAspectRatio}
          onCropComplete={this.handleBannerCropComplete}
          width={2378}
          height={300}
        />
      </>
    );
  }
}

export default CreateOrganization;
